<template>
	<div id="app">
		<Login v-if="!isLoggedIn" />
		<Room v-else />
	</div>
</template>

<script>
import { mapState } from 'vuex'

import Login from './views/Login.vue'
import Room from './views/Room.vue'

export default {
	name: 'App',
	components: {
		Login,
		Room
	},
	computed: mapState({
		isLoggedIn: state => !!state.username
	})
}
</script>

<style>
body {
	display: flex;
	justify-content: center;
}

#app {
	font-family: 'Roboto', Arial, sans-serif;
	font-size: 14px;
	max-width: 420px;
	padding: 15px;
	width: 100%;
}

#app .md-card {
	width: 100%;
}
</style>
